import { Component } from '@angular/core';

import { PaymentSourcesService } from 'src/app/purchase/services/payment-sources.service';
import { TaxExemptionService } from 'src/app/purchase/services/tax-exemption.service';

import { PlansService } from 'src/app/components/plans/plans.service';

import { HelpWidgetFactory } from 'src/app/ajs-upgraded-providers';
import { Subscription } from 'src/app/api/subscription';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { AI_CREDITS_QUANTITY_STEP } from 'src/app/components/plans/plans.service';
import { BillingUtilsService } from '../../services/billing-utils.service';
import { SubscriptionService } from '../../services/subscription.service';

@Component({
  selector: 'subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss'],
  standalone: false,
})
export class SubscriptionComponent {
  public company = this.companyStateService.getCopyOfSelectedCompany();
  public canAccessUnlimitedPlan = this.companyStateService.isK12Customer();

  changePoNumber = this.subscriptionService.changePoNumber.bind(
    this.subscriptionService,
  );

  get itemSubscription() {
    return this.subscriptionService.getItemSubscription();
  }

  get subscriptionPlan() {
    return this.itemSubscription && this.itemSubscription.plan?.item_price_id
      ? this.plansService.getPlanById(this.itemSubscription.plan.item_price_id)
      : undefined;
  }

  get planType() {
    return this.plansService.getPlanType(this.subscriptionPlan);
  }

  get displayCount() {
    return this.itemSubscription?.plan?.quantity || 0;
  }

  get licenseQuantityMultiplier(): number {
    return this.isAdditionalAiCreditsPlan(this.itemSubscription)
      ? AI_CREDITS_QUANTITY_STEP
      : 1;
  }

  get pendingChangeUnitLabel(): string {
    return this.isAdditionalAiCreditsPlan(this.itemSubscription)
      ? 'AI credits'
      : 'display licenses';
  }

  showAddOnRemoveLink(subscription?: Subscription): boolean {
    return !!(subscription?.plan && subscription.plan.quantity >= 1);
  }

  constructor(
    private companyStateService: CompanyStateService,
    public subscriptionService: SubscriptionService,
    public paymentSourcesFactory: PaymentSourcesService,
    public taxExemptionFactory: TaxExemptionService,
    private plansService: PlansService,
    public billingUtils: BillingUtilsService,
    public helpWidgetFactory: HelpWidgetFactory,
  ) {
    this.paymentSourcesFactory.init();
    this.taxExemptionFactory.init();
  }

  showCardRemove(card) {
    return (
      this.itemSubscription.payment_source_id !== card.payment_source.id &&
      this.paymentSourcesFactory.existingCreditCards.length > 1 &&
      this.subscriptionService.getItemCustomer().primary_payment_source_id !==
        card.payment_source.id
    );
  }

  isDisplayLicensePlan(subscription?: Subscription) {
    if (
      !subscription ||
      !subscription.plan ||
      !subscription.plan.item_price_id
    ) {
      return false;
    }

    var plan = this.plansService.getPlanById(subscription.plan.item_price_id);

    return this.plansService.isDisplayLicensePlan(plan);
  }

  isInteractiveLicensePlan(subscription?: Subscription) {
    if (
      !subscription ||
      !subscription.plan ||
      !subscription.plan.item_price_id
    ) {
      return false;
    }

    var plan = this.plansService.getPlanById(subscription.plan.item_price_id);

    return this.plansService.isInteractiveLicensePlan(plan);
  }

  isAdditionalAiCreditsPlan(subscription?: Subscription) {
    if (
      !subscription ||
      !subscription.plan ||
      !subscription.plan.item_price_id
    ) {
      return false;
    }

    var plan = this.plansService.getPlanById(subscription.plan.item_price_id);

    return this.plansService.isAdditionalAiCreditsPlan(plan);
  }

  isVolumePlan(subscription?: Subscription) {
    if (
      !subscription ||
      !subscription.plan ||
      !subscription.plan.item_price_id
    ) {
      return false;
    }

    var plan = this.plansService.getPlanById(subscription.plan.item_price_id);

    return this.plansService.isVolumePlan(plan);
  }

  getPlanName(subscription: Subscription) {
    if (
      !subscription ||
      !subscription.plan ||
      !subscription.plan.item_price_id
    ) {
      return '';
    }

    var plan = this.plansService.getPlanById(subscription.plan.item_price_id);

    return (plan && plan.name + ' Plan') || subscription.plan.item_price_id;
  }

  get shouldShowTaxExemptionButton() {
    const customer = this.subscriptionService.getItemCustomer();

    if (!customer) return false;
    const isTaxable = customer.taxability === 'taxable';
    const isExpired = this.subscriptionService.isTaxExemptionExpired;
    const isFormHidden = !this.taxExemptionFactory.taxExemption.show;

    return (isTaxable || isExpired) && isFormHidden;
  }
}
